export const uiSchema = {
  "ui:title": "schemaTypes.identifier_type",
  id: {
    "ui:title": "generic.id",
    "ui:colspan": 2,
  },
  identifier_type: {
    "ui:title": "views.admin.identifiers.identifier_type",
    "ui:colspan": 10,
  },
  description: {
    "ui:title": "generic.description",
  },
  rules: {
    textCase: {
      "ui:title": "views.admin.identifiers.rules.textCase",
      "ui:disabled": false,
    },
    allowOnlyOne: {
      "ui:title": "views.admin.identifiers.rules.allowOnlyOne",
    },
    type: {
      "ui:title": "views.admin.identifiers.rules.type",
    },
    doesNotEqualOwnerSlug: {
      "ui:title": "views.admin.identifiers.rules.doesNotEqualOwnerSlug",
    },
  },
};
